"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("./store/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var withModalApi = function withModalApi(Component) {
  var WithModalApi = function WithModalApi(_ref) {
    var mapActions2Store = _ref.mapActions2Store,
      modalKey = _ref.modalKey,
      props = _ref.props,
      onClose = _ref.onClose;
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useStore = (0, _reactRedux.useStore)(),
      getState = _useStore.getState;
    var handleClose = (0, _react.useCallback)(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return dispatch((0, _actions.close)(modalKey, args)), dispatch((0, _actions.destroy)(modalKey)), onClose.apply(void 0, args.concat([dispatch, getState]));
    }, [dispatch, getState, modalKey, onClose]);
    var actions = (0, _react.useMemo)(function () {
      return mapActions2Store ? R.call(R.pipe(R.toPairs, R.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          actionName = _ref3[0],
          action = _ref3[1];
        return [actionName, R.partial(action, [dispatch, getState])];
      }), R.fromPairs), mapActions2Store) : {};
    }, [dispatch, getState, mapActions2Store]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, actions, props, {
      onClose: handleClose
    }));
  };
  WithModalApi.propTypes = {
    modalKey: _propTypes.default.string.isRequired,
    mapActions2Store: _propTypes.default.object,
    props: _propTypes.default.object,
    onClose: _propTypes.default.func
  };
  WithModalApi.defaultProps = {
    props: {},
    onClose: function onClose() {}
  };
  return WithModalApi;
};
var _default = exports.default = withModalApi;